<template>
  <div class="container" style="position: relative;">
    <div id="about" style="position: absolute; top: -80px; left: 0"></div>
    <md-card class="customCard">
      <md-card-content>
        <h2 class="title">Über uns</h2>
        <div class="md-layout">
          <div class="md-layout-item">
            <p>
              Balkon &amp; Zaun-Profi Leibhammer + Rietz GmbH bietet persönlich zugeschnittene Lösungen rund ums Haus aus Aluminium.
              Aluminium ist ein besonders witterungsbeständiges und pflegeleichtes Leichtmetall. 
              Durch Eloxierung oder Farbpulverbeschichtung, laut RAL-Karte entscheiden Sie sich für unsere überaus kratzfesten und robusten Aluminium-Konstruktionen, 
              die viele Jahrzehnte ohne das sonst übliche Nachstreichen auskommen! <br><br> Wir entwickeln spezielle Lösungen für Ihr Haus von Anfang an mit Ihnen persönlich.
              Jede bauliche und gestalterische Gegebenheit wird aufgegriffen und sinnvoll in die Planung und Ausführung mit eingebaut. <br>
            </p>
          </div>
          <div class="md-layout-item img-size" style="margin-right: 3vw;">
            <img
              :src="companyImage"
              class="rounded z-depth-1-half"
              :class="{ '': responsive }"/>
            <h4>Unser Hauptsitz</h4>
          </div>
          <div class="md-layout-item">
            <p>
              Nach Terminvereinbarung mit Herrn Rietz, wird vor Ort mit dem Kunden in jedem Detail die Wünsche zu realisieren versucht. 
              Da alle Produkte von uns Maßanfertigungen sind, ist es unbedingt notwendig, dass Herr Rietz vor Ort sich Ihr Haus ansieht, 
              um Sie dann in jeder Hinsicht, z.B. Gestaltung, Farbe usw., genauestens zu beraten. <br><br>
              Dann macht Herr Rietz ein genaues Aufmaß und erstellt Ihnen vor Ort ein Angebot mit einem Festpreis, dies kostenlos.
              Nach Auftragserteilung wird Ihr Produkt bei uns termingerecht hergestellt und vor Ort montiert. 
              Bei der Montage wird Ihre alte Anlage abgebaut und von uns entsorgt und Ihre Neue anmontiert. Auch bei der Montage ist unser Herr Rietz wieder bei Ihnen vor Ort.
            </p>
          </div>
          <div class="md-layout-item img-size">
            <img
              :src="profileImage"
              class="rounded z-depth-1-half"
              :class="{ 'responsive-image': responsive }"/>
            <h4>Frank-Rüdiger Rietz</h4>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
       profileImage: require("@/assets/images/RietzProfile.jpg"),
       companyImage: require("@/assets/images/company.jpg"),
    };
  }
};
</script>

